import { useSearchParams } from "react-router-dom";
import { useAuth } from "../contexts/AuthContext";
import { TABLE_TYPES } from "../layout/onboarding/config/tableConfig";
import AccessDeniedPage from "../pages/AccessDeniedPage";
import { ROLES } from "../constants/roles";
import { getDefaultOnboardTableType } from "../utils/getDefaultOnboardTableType";

const OnboardingProtectedRoute = ({ children }) => {
  const [searchParams] = useSearchParams();

  const { hasLeadViewAccess, hasAccess, effectiveRoles } = useAuth();

  const defaultTableType = getDefaultOnboardTableType(effectiveRoles);

  const tab = searchParams.get("tab") || defaultTableType;

  let allowed = false;

  switch (tab) {
    case TABLE_TYPES.LEADS:
      allowed = hasLeadViewAccess();
      break;

    case TABLE_TYPES.ONBOARDED:
    case TABLE_TYPES.PRE_ONBOARDING:
      allowed = hasAccess(ROLES.ONBOARDING);
      break;

    default:
      allowed = false;
  }

  return allowed ? children : <AccessDeniedPage />;
};

export default OnboardingProtectedRoute;
